/*
 * @file 定義
 */

import { getStorage } from 'utils/localstorage'

// api
export const AUTH_TOKEN = getStorage('access_token')

// media-query
export const SP_WIDTH = 767
export const MEDIA_QUERY = {
  SP: `@media screen and (max-width: ${SP_WIDTH}px)`,
  PC: `@media screen and (min-width: ${SP_WIDTH + 1}px)`,
}
